import merge from 'lodash/merge';
import BackboneElement from './BackboneElement';

export default class BN_Asam4LevelOfCareReviewCriteria extends BackboneElement {
    static __className = 'BN_Asam4LevelOfCareReviewCriteria';

    __objectStructure = {
        id: String,
        text: String,
        subcriteria: [BN_Asam4LevelOfCareReviewCriteria],
    };

    constructor(constructJson, className = 'BN_Asam4LevelOfCareReviewCriteria') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson);

        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
